import { useGLTF, RoundedBox } from "@react-three/drei";
import { RigidBody, CuboidCollider } from "@react-three/rapier";
import { useMemo } from "react";
import { COLORS } from "../../constants/colors";
import TreeShadow from "./TreeShadow.jsx";
import { MODELS } from "../loader/models.js";

const Tree = ({ position = [0, 0, 0], rotation = [0, 0, 0] }) => {
  const tree = useGLTF(MODELS.TREE);

  // Клонируем сцену для каждого экземпляра
  const clonedScene = useMemo(() => {
    return tree.scene.clone();
  }, [tree.scene]);

  return (
    <group position={position} rotation={rotation}>
      <TreeShadow size={4.5} opacity={0.4} softness={0.8} />
      <primitive scale={1} position-y={-0.6} object={clonedScene} />
      <RigidBody type="fixed" ccd={false}>
        <CuboidCollider args={[0.75, 0.25, 0.75]} />
        <RoundedBox args={[1.5, 0.5, 1.5]} radius={0.2} position-y={-1}>
          <meshStandardMaterial color={COLORS.wood} />
        </RoundedBox>
      </RigidBody>
    </group>
  );
};

export default Tree;
